<template>
  <component :is="component" :filterData="filterData" :paginationData="paginationData" :parentCategory="parentCategory"
             :childCategory="childCategory" v-if="component"/>
</template>

<script>
export default {
  name: "UtilityFilterLink",
  mixins: [],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    filterLayout: {},
    filterData: {
      default: () => {
      }
    },
    paginationData: {
      default: () => {
        return {total: 0, page: 0, size: 0,}
      }
    },
    categoryData: [],
    parentCategory: [],
    childCategory: {},
  },
  data() {
    return {
      component: null,
    }
  },
  beforeRouterEnter() {
  },
  created() {

  },
  mounted() {
    this.filterLoader();
  },
  beforeDestroy() {

  },
  destroyed() {
  },
  computed: {
    loader() {
      if (!this.filterLayout) {
        return null
      }
      return () => import(`@/template/utility/filter/${this.filterLayout}`)
    },
  },
  methods: {
    filterLoader() {
      this.loader()
        .then(() => {
          this.component = () => this.loader()
        })
        .catch(() => {
          this.component = () => import('@/template/utility/filter/UtilityFilterDefaultLayout')
        })
    },
  },
  watch: {},
}

</script>
